<div
  *ngIf="editFormGroups.length > 0; else showOne"
  class="update-record-dialog"
>
  <section class="record-summary" aria-label="Issue context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-exclamation-triangle"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Edit Active Issues</span>
      <h2>
        {{ editFormData?.length }} issue{{
          editFormData?.length !== 1 ? "s" : ""
        }}
        selected
      </h2>
    </div>
  </section>

  <ng-container *ngFor="let desc of editFormData; let i = index">
    <section class="form-section">
      <div class="form-section__header">
        <h3>Issue {{ i + 1 }}</h3>
      </div>

      <form [formGroup]="editFormGroups[i]">
        <div class="form-grid">
          <div class="form-field">
            <label>Vehicle Reference</label>
            <p-dropdown
              placeholder="Select a Vehicle"
              formControlName="vehicle_reference"
              optionLabel="vehicle_reference"
              [options]="vehicleList"
              optionValue="vehicle_reference"
              [filter]="true"
              filterBy="vehicle_reference"
              appendTo="body"
              styleClass="w-full"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="form-field">
            <label>Description</label>
            <p-autoComplete
              formControlName="description"
              [suggestions]="suggestedDescriptions"
              (completeMethod)="filterDescriptions($event)"
              (onSelect)="onDescriptionSelect($event)"
              field="value"
              [dropdown]="true"
              [minLength]="1"
              [autoHighlight]="true"
              [scrollHeight]="'200px'"
              placeholder="Issue"
              appendTo="body"
            >
              <ng-template let-issue pTemplate="item">
                <div>{{ issue.label }}</div>
              </ng-template>
            </p-autoComplete>
            <small
              class="p-error"
              *ngIf="
                editFormGroups[i].get('description')?.invalid &&
                editFormGroups[i].get('description')?.touched
              "
            >
              <strong>Description</strong> is required
            </small>
          </div>

          <div class="form-field form-field--wide">
            <label>Remarks</label>
            <textarea
              pInputTextarea
              formControlName="remarks"
              rows="3"
              class="w-full"
            ></textarea>
            <small
              class="p-error"
              *ngIf="
                editFormGroups[i].get('remarks')?.invalid &&
                (editFormGroups[i].get('remarks')?.touched ||
                  editFormGroups[i].get('remarks')?.dirty)
              "
            >
              <strong>Remarks</strong> are required
            </small>
          </div>
        </div>
      </form>
    </section>
  </ng-container>

  <div class="dialog-actions">
    <button
      pButton
      type="button"
      icon="pi pi-check"
      label="Update Issue"
      class="p-button-primary w-full"
      [loading]="loading"
      (click)="onActiveIssueFormSubmit()"
    ></button>
  </div>
</div>

<ng-template #showOne>
  <form
    class="update-record-dialog"
    [formGroup]="activeIssueForm"
    (ngSubmit)="onActiveIssueFormSubmit()"
  >
    <section class="record-summary" aria-label="Issue context">
      <div class="record-summary__icon" aria-hidden="true">
        <i class="pi pi-exclamation-triangle"></i>
      </div>

      <div class="record-summary__copy">
        <span class="record-summary__eyebrow">Active Issue</span>
        <h2>
          {{ activeIssueForm.get("vehicle_reference")?.value || "New issue" }}
        </h2>
      </div>
    </section>

    <section class="form-section">
      <div class="form-section__header">
        <h3>Issue details</h3>
      </div>

      <div class="form-grid">
        <div class="form-field">
          <label>Vehicle Reference</label>
          <p-dropdown
            placeholder="Select a Vehicle"
            formControlName="vehicle_reference"
            optionLabel="vehicle_reference"
            [options]="vehicleList"
            optionValue="vehicle_reference"
            (onChange)="onChangeVehicle($event)"
            [filter]="true"
            filterBy="vehicle_reference"
            appendTo="body"
            styleClass="w-full"
          ></p-dropdown>
          <small
            class="p-error"
            *ngIf="
              activeIssueForm.get('vehicle_reference')?.invalid &&
              (activeIssueForm.get('vehicle_reference')?.touched ||
                activeIssueForm.get('vehicle_reference')?.dirty)
            "
          >
            <strong>Vehicle Reference</strong> is required
          </small>
        </div>

        <div class="form-field">
          <label>Description</label>
          <p-autoComplete
            formControlName="description"
            [suggestions]="suggestedDescriptions"
            (completeMethod)="filterDescriptions($event)"
            (onSelect)="onDescriptionSelect($event)"
            field="label"
            [dropdown]="true"
            [minLength]="1"
            [autoHighlight]="true"
            [multiple]="true"
            [scrollHeight]="'200px'"
            placeholder="Issue"
            appendTo="body"
          ></p-autoComplete>

          <small
            class="p-error"
            *ngIf="
              activeIssueForm.get('description')?.invalid &&
              (activeIssueForm.get('description')?.touched ||
                activeIssueForm.get('description')?.dirty)
            "
          >
            <strong>Description</strong> is required
          </small>
        </div>

        <div class="form-field form-field--wide">
          <label>Remarks</label>
          <textarea
            pInputTextarea
            formControlName="remarks"
            rows="3"
            class="w-full"
          ></textarea>
          <small
            class="p-error"
            *ngIf="
              activeIssueForm.get('remarks')?.invalid &&
              (activeIssueForm.get('remarks')?.touched ||
                activeIssueForm.get('remarks')?.dirty)
            "
          >
            <strong>Remarks</strong> are required
          </small>
        </div>
      </div>
    </section>

    <div class="dialog-actions">
      <button
        pButton
        type="submit"
        icon="pi pi-check"
        [label]="isInEditMode ? 'Update Issue' : 'Add Issue'"
        class="p-button-primary w-full"
        [loading]="loading"
      ></button>
    </div>
  </form>
</ng-template>
